module.exports = __webpack_public_path__ + "img/Women’s Multivitamin.344d9b00.jpg";